import Note from "../scene/drivers/Note.js";
import InputNoteArea from "./InputNoteArea.js";
import ConfirmationArea from "./ConfirmationArea.js";

import Menu from "../Menu.js";

import global from "../global.js";

//const log = global.log.getLogger("f_mtac.ui.NotesUpdateArea");

let NotesUpdateArea = function () {
    var tools = global.tools;
    var scene = global.scene;
    var selected = null;

    const NOTE_CHAR_LIMIT = 32;
    const NOTE_LINE_LIMIT = 4;

    const soft_wrap = (s) =>
        String(s)
            .replace(/(?![^\n]{1,32}$)([^\n]{1,32})\s/g, "$1\n")
            .split("\n");
    /*const hard_wrap = (s) => {
        log.error("hard_wrap text = ",s);
        var w = Array.from(Array(NOTE_LINE_LIMIT), () => ""), cn = 0;
        for (let l = 0; l < NOTE_LINE_LIMIT; l++) {
            for (let n = 0; n < NOTE_CHAR_LIMIT; n++) {
                let c = String(s).charAt(cn++);
                if (c === "\n" || c === "") {
                    break;
                }
                w[l] += c;
            }
            log.error("line = ",w[l]);
        }
        if (String(s).charAt(cn) !== "") {
            return null;
        }
        log.error("hard_wrap w = ",w);
        return w;
    };*/
    const check_limits = (w) => {
        if (w.length > NOTE_LINE_LIMIT) {
            return false;
        }
        for (let l of w) {
            if (l.length > NOTE_CHAR_LIMIT) {
                return false;
            }
        }
        return true;
    };

    let unselect = () => {
        if (selected === null) {
            return;
        }
        scene.shadow.unaffect(selected.handle);
        selected = null;
    };

    let select = (node) => {
        if (selected !== null) {
            unselect();
        }
        selected = scene.objects.get_by_node("notes", node);
        scene.shadow.affect(selected.handle);
    };

    Object.defineProperty(this, "selected", {
        set: () => {},
        get: () => selected
    });

    this.select = async (handle) => {
        if (scene.mode_switcher.mode !== "graphics") {
            return;
        }
        await Menu.close("notes_update_area");
        select(handle);
        let color_value = $(selected.handle.node()).find("rect[stroke]").attr("stroke");
        if (color_value in scene.color_by_value) {
            let color = scene.color_by_value[color_value];
            tools.group_select("notes_colors_update", `notes_color_update${color.name}`);
        }
        await Menu.display(["notes_update_area"]);
    };

    this.init = function () {
        tools = global.tools;
        scene = global.scene;

        Menu.create({
            name: "notes_update_area",
            icon: "graphics",
            contents: ["note_rename", "note_colors_update", "note_duplicate", "note_delete"],
            open_handler: () => {
                scene.disable_draggable_tools();
            },
            close_handler: () => {
                if (scene.objects.layers.media.ids.length > 0) {
                    scene.enable_draggable_tools();
                }
                unselect();
            },
            close_timer: true
        });

        tools.register({
            name: "note_rename",
            icon: "rename",
            position: "#note_rename",
            handler: async () => {
                Menu.unset_close_timeout(["notes_update_area"]);
                let note = Note.import(selected);
                let cur_text = note.text[0];
                for (let i = 1; i < note.text.length; i++) {
                    cur_text += "\n" + note.text[i];
                }
                let note_text = await InputNoteArea.interact({
                    tip: global.internationalization.text("postit.Text-of-the-note"),
                    validate_change: (new_text) => {
                        return check_limits(soft_wrap(new_text));
                    },
                    error_message: global.internationalization.text("postit.Text-required-shall-not-exceed-number-lines-and-number-characters"),
                    current_text: cur_text
                });
                if (note_text === null) {
                    return;
                }
                let wrap_text = soft_wrap(note_text);
                note.write_text(wrap_text);
                note.detach();
                scene.objects.tx_update("notes", selected);
                Menu.set_close_timeout(["notes_update_area"]);
            }
        });

        tools.register({
            name: "duplicate_note",
            icon: "duplicate f_mtac-icon-xlg",
            position: "#note_duplicate",
            handler: async () => {
                Menu.unset_close_timeout(["notes_update_area"]);
                let old_object = selected;
                let note = Note.import(old_object);
                let cur_text = note.text[0];
                for (let i = 1; i < note.text.length; i++) {
                    cur_text += "\n" + note.text[i];
                }
                let note_text = await InputNoteArea.interact({
                    tip: global.internationalization.text("postit.Text-of-the-note"),
                    validators: {
                        required: true
                    },
                    validate_change: (new_text) => {
                        return check_limits(soft_wrap(new_text));
                    },
                    error_message: global.internationalization.text("postit.Text-required-shall-not-exceed-number-lines-and-number-characters"),
                    current_text: cur_text
                });
                if (note_text === null) {
                    return;
                }
                let new_object = scene.objects.duplicate("notes", old_object);
                let angle = Math.random() * 2 * Math.PI;
                new_object.move({
                    x: (50 * Math.cos(angle)) / scene.root_transform.k,
                    y: (50 * Math.sin(angle)) / scene.root_transform.k
                });
                let new_note = Note.import(new_object);
                let wrap_text = soft_wrap(note_text);
                new_note.write_text(wrap_text);
                await scene.objects.publish("notes", new_object);
                await this.select(new_object.handle.node());
                Menu.set_close_timeout(["notes_update_area"]);
            }
        });

        tools.register({
            name: "delete_note",
            icon: "suppp f_mtac-icon-xlg",
            position: "#note_delete",
            handler: async () => {
                ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("postit.Delete-note")
                }).then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }
                    let object = selected;
                    scene.objects.tx_delete("scene", object);
                    Menu.close("notes_update_area");
                });
            }
        });

        tools.register_group({
            name: "notes_colors_update",
            target: "$none",
            enable: (_, selected_tool) => {
                let object = selected;
                let color = selected_tool.data.color.value;
                scene.object_color(object, color);
                scene.objects.tx_update("notes", object);
            },
            disable: () => {}
        });
        scene.colors.forEach((color) => {
            tools.register({
                group: "notes_colors_update",
                name: `notes_color_update${color.name}`,
                data: {color},
                icon: "drop_black",
                position: "#note_colors_update",
                style: {color: color.value, "text-stroke": "1px #fff"}
            });
        });
    };

    global.event_bus.subscribe("init", () => {
        this.init();
    });
};

export default new NotesUpdateArea();
